/**
 * Exact-match EN -> NL dictionary. `tr(text)` returns the Dutch string when the
 * language is NL and a translation exists, otherwise the original English.
 * Add a key here and it is translated everywhere that string is used.
 */
export const NL = {
  // ---- V2 positioning
  "Social media that practically runs itself.": "Social media die vrijwel zichzelf runt.",
  "Your social media.": "Jouw social media.",
  "Almost on autopilot.": "Bijna op de automatische piloot.",
  "PostMint learns your business and helps create, plan and publish your social media content automatically.":
    "PostMint leert jouw bedrijf kennen en helpt je content automatisch te maken, plannen en publiceren.",
  "From captions and graphics to your monthly content calendar — everything lives in one place.":
    "Van captions en visuals tot je maandkalender — alles op één plek.",
  "Start Free": "Gratis starten",
  "See How It Works": "Bekijk hoe het werkt",
  "One setup. A month of content.": "Eén keer instellen. Een maand content.",
  "Nothing publishes without your approval.": "Niets wordt gepubliceerd zonder jouw goedkeuring.",
  "From €19/month.": "Vanaf €19 per maand.",
  "No credit card required for the free plan. Cancel anytime according to the subscription terms.":
    "Geen creditcard nodig voor het gratis plan. Opzeggen kan altijd volgens de abonnementsvoorwaarden.",
  "From idea to published post in minutes.": "Van idee tot gepubliceerde post in enkele minuten.",
  "Your brand. Your approval. PostMint handles the rest.":
    "Jouw merk. Jouw goedkeuring. PostMint doet de rest.",
  "PostMint learns your business": "PostMint leert je bedrijf kennen",
  "Enter your website and PostMint suggests your Brand Profile — what you sell, who you speak to and how you sound. You check it and correct anything.":
    "Vul je website in en PostMint stelt je merkprofiel voor: wat je verkoopt, wie je klanten zijn en hoe je klinkt. Jij controleert en past aan.",
  "Connect your accounts": "Koppel je accounts",
  "Link Instagram, Facebook, LinkedIn or TikTok. We never ask for your passwords — connections use the platforms' own sign-in.":
    "Koppel Instagram, Facebook, LinkedIn of TikTok. We vragen nooit om je wachtwoorden — koppelen gaat via de inlog van het platform zelf.",
  "Generate your month": "Genereer je maand",
  "One click builds a full month: captions per platform, story and Reel concepts, visuals and a content calendar.":
    "Eén klik maakt een volle maand: captions per platform, story- en Reel-concepten, visuals en een contentkalender.",
  "Approve once, publish automatically": "Eén keer goedkeuren, automatisch publiceren",
  "You review and approve. PostMint schedules everything and publishes it for you at the recommended times.":
    "Jij beoordeelt en keurt goed. PostMint plant alles in en publiceert het op de aanbevolen tijden.",
  "Minutes, not hours": "Minuten, geen uren",
  "Set PostMint up once and spend a few minutes a week on social media.":
    "Stel PostMint één keer in en besteed daarna een paar minuten per week aan social media.",
  "A month at a time": "Een maand in één keer",
  "Generate a complete content calendar in one click.": "Maak een complete contentkalender met één klik.",
  "Sounds like you": "Klinkt als jij",
  "Every caption is written from your verified Brand Profile.":
    "Elke caption komt uit jouw gecontroleerde merkprofiel.",
  "Promotions become campaigns": "Acties worden campagnes",
  "Describe an offer once and PostMint builds the whole run of posts around it.":
    "Beschrijf je actie één keer en PostMint bouwt de hele reeks posts eromheen.",
  "Publishes for you": "Publiceert voor jou",
  "Approved posts are scheduled and published to your connected accounts automatically.":
    "Goedgekeurde posts worden automatisch ingepland en op je gekoppelde accounts gepubliceerd.",
  "You stay in control": "Jij houdt de regie",
  "Nothing is published without your approval — unless you switch that on yourself.":
    "Er wordt niets gepubliceerd zonder jouw goedkeuring — tenzij je dat zelf aanzet.",

  // ---- interactive demo
  "Try it now": "Probeer het nu",
  "Tell us three things about your business and watch PostMint write a real post for it.":
    "Vertel ons drie dingen over je bedrijf en zie PostMint er een echte post voor schrijven.",
  "Business type": "Type bedrijf",
  "Business name": "Bedrijfsnaam",
  "What do you want to promote?": "Wat wil je promoten?",
  "Generate Example": "Genereer voorbeeld",
  "Writing your example…": "Je voorbeeld wordt geschreven…",
  "Please fill in all three fields so we can create a useful example.":
    "Vul alle drie de velden in zodat we een bruikbaar voorbeeld kunnen maken.",
  "Examples are generated for demonstration. Always check facts, prices and dates before publishing.":
    "Voorbeelden zijn ter demonstratie gegenereerd. Controleer feiten, prijzen en datums altijd voor je publiceert.",
  "Your example appears here.": "Je voorbeeld verschijnt hier.",
  "PostMint writes an Instagram caption, a Facebook version, a story and a Reel concept — the same way it does for paying customers every month.":
    "PostMint schrijft een Instagram-caption, een Facebook-versie, een story en een Reel-concept — net zoals elke maand voor betalende klanten.",
  Example: "Voorbeeld",
  "Instagram caption": "Instagram-caption",
  "Facebook caption": "Facebook-caption",
  "Story concept": "Story-concept",
  "Reel concept": "Reel-concept",
  "Visual idea": "Visueel idee",
  "Please verify before publishing": "Controleer dit voor je publiceert",
  "Create another version": "Maak een andere versie",

  // ---- pricing V2
  "Start free. Automate when you're ready.": "Begin gratis. Automatiseer wanneer je er klaar voor bent.",
  "PostMint is software, so it costs a fraction of an agency. Try it on your own business first and upgrade when you want scheduling and automatic publishing.":
    "PostMint is software en kost dus een fractie van een bureau. Probeer het eerst op je eigen bedrijf en upgrade wanneer je wil inplannen en automatisch publiceren.",
  Monthly: "Maandelijks",
  "Annual — 2 months free": "Jaarlijks — 2 maanden gratis",
  "billed yearly — you save": "per jaar gefactureerd — je bespaart",
  or: "of",
  "per year": "per jaar",
  "Free forever": "Altijd gratis",
  From: "Vanaf",
  "/ month, on top of your plan": "per maand, bovenop je abonnement",
  "Optional human service": "Optionele menselijke service",
  "Prefer someone else to run PostMint for you? Our team can do it.":
    "Liever dat iemand anders PostMint voor je runt? Ons team doet dat graag.",
  "Contact Sales": "Neem contact op",
  "Human content review before anything goes live": "Menselijke controle voordat er iets live gaat",
  "Content adjustments by our team": "Aanpassingen aan content door ons team",
  "Campaign assistance": "Hulp bij campagnes",
  "Monthly optimisation": "Maandelijkse optimalisatie",
  "Priority support": "Prioriteitssupport",
  "Questions about the plans.": "Vragen over de abonnementen.",
  "AI generations and visuals run on fair-use allowances, so you always know what you're paying. Reaching an allowance never deletes your content.":
    "AI-generaties en visuals werken met fair-use limieten, zodat je altijd weet wat je betaalt. Een limiet bereiken verwijdert nooit je content.",
  "Start Starter": "Start met Starter",
  "Start Grow": "Start met Grow",
  "Start Pro": "Start met Pro",

  // ---- get started V2
  "Let's put your social media on autopilot.": "Zet je social media op de automatische piloot.",
  "Two quick steps: pick a plan — Free works fine to start — then create your account. You'll build your Brand Profile right after.":
    "Twee snelle stappen: kies een abonnement — Gratis is een prima start — en maak je account aan. Daarna bouw je je merkprofiel.",
  "Choose your plan": "Kies je abonnement",
  Free: "Gratis",
  "Signing up with Google starts you on the Free plan. You can switch plans from your dashboard at any time.":
    "Aanmelden met Google start je op het gratis plan. Je kunt op elk moment van abonnement wisselen in je dashboard.",
  // ---- pricing & general FAQ (V2)
  "Is the free plan really free?": "Is het gratis plan echt gratis?",
  "Yes. You can create your Brand Profile, generate example posts, try AI captions and see your calendar without paying anything. Scheduling and automatic publishing start on the paid plans.":
    "Ja. Je kunt je merkprofiel maken, voorbeeldposts genereren, AI-captions uitproberen en je kalender bekijken zonder te betalen. Inplannen en automatisch publiceren horen bij de betaalde abonnementen.",
  "Can I change plans?": "Kan ik van abonnement wisselen?",
  "Yes. You can upgrade or downgrade from the Subscription page in your dashboard at any time.":
    "Ja. Je kunt op elk moment up- of downgraden via de pagina Abonnement in je dashboard.",
  "What is an AI generation?": "Wat is een AI-generatie?",
  "One generation is one piece of content PostMint writes for you — a caption, a story concept, a Reel script or one post in a campaign. Your remaining allowance is always visible in your dashboard.":
    "Eén generatie is één stuk content dat PostMint voor je schrijft: een caption, een story-concept, een Reel-script of één post in een campagne. Je resterende limiet staat altijd in je dashboard.",
  "What happens if I reach my monthly allowance?": "Wat als ik mijn maandlimiet bereik?",
  "Nothing is deleted. You keep everything already created and can either upgrade, wait for your allowance to renew, or buy extra credits where that is supported.":
    "Er wordt niets verwijderd. Je houdt alles wat al gemaakt is en kunt upgraden, wachten tot je limiet vernieuwt of extra credits kopen waar dat mogelijk is.",
  "Does PostMint publish my posts automatically?": "Publiceert PostMint mijn posts automatisch?",
  "Only after you approve them, and only to accounts you have connected. Automatic publishing is included on Starter, Grow and Pro.":
    "Alleen nadat jij ze goedkeurt, en alleen naar accounts die je zelf hebt gekoppeld. Automatisch publiceren zit bij Starter, Grow en Pro.",
  "Why is annual billing cheaper?": "Waarom is jaarlijks betalen goedkoper?",
  "Annual plans are billed once for ten months of the monthly price, so you effectively get two months free. The exact saving is shown on each plan.":
    "Bij een jaarabonnement betaal je in één keer tien maanden, dus krijg je effectief twee maanden gratis. De exacte besparing staat bij elk abonnement.",
  "Do I still need someone to make my content?": "Heb ik nog iemand nodig die mijn content maakt?",
  "No. That is the point of PostMint — normal customers never need a PostMint employee to build their month. If you would still prefer human help, PostMint Managed is available separately.":
    "Nee. Dat is precies het idee van PostMint: klanten hebben geen PostMint-medewerker nodig om hun maand te vullen. Wil je toch menselijke hulp, dan is PostMint Managed los verkrijgbaar.",
  "Do I need to know anything about marketing?": "Moet ik iets van marketing weten?",
  "How does PostMint learn about my business?": "Hoe leert PostMint mijn bedrijf kennen?",
  "You enter your website and PostMint reads the publicly available information on it to suggest your business description, services, tone and brand colours. You review and correct everything before it becomes part of your Brand Profile.":
    "Je vult je website in en PostMint leest de openbare informatie daarop om je bedrijfsbeschrijving, diensten, toon en merkkleuren voor te stellen. Jij controleert en corrigeert alles voordat het in je merkprofiel komt.",
  "No. Every post is written from your verified Brand Profile, your industry, your promotions and your own photos — and each platform gets its own version rather than the same text copied everywhere.":
    "Nee. Elke post komt uit je gecontroleerde merkprofiel, je branche, je acties en je eigen foto's — en elk platform krijgt een eigen versie in plaats van overal dezelfde tekst.",
  "Can PostMint invent things about my business?": "Kan PostMint dingen over mijn bedrijf verzinnen?",
  "It is explicitly instructed not to. PostMint never makes up prices, opening hours, addresses, ingredients or event dates. If something needs checking, the post is flagged so you verify it before publishing.":
    "Dat is expliciet verboden. PostMint verzint nooit prijzen, openingstijden, adressen, ingrediënten of datums. Moet iets gecontroleerd worden, dan wordt de post gemarkeerd zodat je het nakijkt voor publicatie.",
  "Does PostMint publish without asking me?": "Publiceert PostMint zonder het mij te vragen?",
  "Which platforms can I connect?": "Welke platforms kan ik koppelen?",
  "Instagram, Facebook, LinkedIn and TikTok, with Google Business Profile where supported. Pinterest, X and YouTube Shorts are planned. We use the platforms' own sign-in and never ask for your passwords.":
    "Instagram, Facebook, LinkedIn en TikTok, en Google Bedrijfsprofiel waar dat ondersteund wordt. Pinterest, X en YouTube Shorts staan op de planning. We gebruiken de inlog van het platform zelf en vragen nooit om je wachtwoorden.",
  "Can I use my own photos?": "Kan ik mijn eigen foto's gebruiken?",
  "Yes. Upload them and PostMint builds content around them, or turns a single photo into a post, story and Reel idea.":
    "Ja. Upload ze en PostMint bouwt er content rond, of maakt van één foto een post, story en Reel-idee.",
  "Can I send in a promotion during the month?": "Kan ik tussentijds een actie doorgeven?",
  "What languages can PostMint write in?": "In welke talen schrijft PostMint?",
  "Dutch and English, including a mix of both. You can set a primary and secondary content language and override the language on individual posts.":
    "Nederlands en Engels, ook gemengd. Je stelt een primaire en secundaire contenttaal in en kunt per post afwijken.",
  "What if I would rather someone did it for me?": "En als ik het liever laat doen?",
  "PostMint Managed is an optional human service on top of your subscription, starting from €199/month. Contact us and we'll talk it through.":
    "PostMint Managed is een optionele menselijke service bovenop je abonnement, vanaf €199 per maand. Neem contact op en we bespreken het.",

  // ---- support desk
  "Ask us anything about your account, billing or content. We reply here and by email — Grow and Pro customers are handled first.":
    "Vraag ons alles over je account, facturatie of content. We antwoorden hier en per e-mail — Grow- en Pro-klanten gaan voor.",
  "Your conversations": "Je gesprekken",
  "Write a reply…": "Schrijf een antwoord…",
  Reply: "Antwoorden",
  "Waiting for us": "Wacht op ons",
  "We replied": "Wij hebben geantwoord",
  Closed: "Gesloten",
  "This conversation is closed. Send a new message above if you need anything else.":
    "Dit gesprek is gesloten. Stuur hierboven een nieuw bericht als je nog iets nodig hebt.",
  "Message sent. We'll come back to you by email too.":
    "Bericht verzonden. We komen ook per e-mail bij je terug.",
  "Reply sent.": "Antwoord verzonden.",

  // ---- free trial
  "Start Free Trial": "Start gratis proefperiode",
  "Try it free for 7 days. Then from €19 a month.": "Probeer 7 dagen gratis. Daarna vanaf €19 per maand.",
  "PostMint is software, so it costs a fraction of an agency. Start with a full 7-day trial and pick a plan when you can see what it does for your business.":
    "PostMint is software en kost dus een fractie van een bureau. Start met een volledige proefperiode van 7 dagen en kies daarna een abonnement.",
  "Start here": "Begin hier",
  "Start your 7-day free trial": "Start je gratis proefperiode van 7 dagen",
  "Try everything in Grow free for 7 days. We ask for your card so your plan continues without interruption — you're charged nothing today, and you can cancel any time during the trial.":
    "Probeer alles uit Grow 7 dagen gratis. We vragen je creditcard zodat je abonnement zonder onderbreking doorloopt — je betaalt vandaag niets en je kunt tijdens de proefperiode altijd opzeggen.",
  "When the trial ends nothing is deleted. Your content, calendar and Brand Profile stay saved — generating, scheduling and publishing simply pause until you choose a plan.":
    "Als de proefperiode eindigt wordt er niets verwijderd. Je content, kalender en merkprofiel blijven bewaard — genereren, inplannen en publiceren pauzeren tot je een abonnement kiest.",
  "Full Grow features for 7 days": "7 dagen alle functies van Grow",
  "60 AI content generations & 10 AI visuals": "60 AI-generaties en 10 AI-visuals",
  "Up to 12 scheduled posts and 2 connected accounts": "Tot 12 ingeplande posts en 2 gekoppelde accounts",
  "Monthly content plan, campaigns and automatic publishing":
    "Maandplan, campagnes en automatisch publiceren",
  "€0 today — cancel during the trial and you're never charged": "Vandaag €0 — zeg op tijdens de proefperiode en je betaalt nooit iets",
  "7 days free, cancel any time.": "7 dagen gratis, altijd opzegbaar.",
  "Card required for the 7-day trial, €0 charged today. Cancel anytime according to the subscription terms.":
    "Voor de proefperiode van 7 dagen is een creditcard nodig; vandaag betaal je €0. Opzeggen kan altijd volgens de abonnementsvoorwaarden.",
  "Start your 7-day free trial.": "Start je gratis proefperiode van 7 dagen.",
  "Create your account, build your Brand Profile and see PostMint working on your own business — €0 during the trial.":
    "Maak je account, bouw je merkprofiel en zie PostMint werken voor jouw bedrijf — tijdens de proefperiode betaal je €0.",
  "Free Trial": "Gratis proefperiode",
  "7 days free, card required": "7 dagen gratis, creditcard vereist",
  "7 days free — card required, €0 today": "7 dagen gratis — creditcard vereist, vandaag €0",
  "Your 7-day trial costs €0 today. Prices exclude VAT where legally applicable.":
    "Je proefperiode van 7 dagen kost vandaag €0. Prijzen zijn exclusief btw waar van toepassing.",
  "Signing up with Google starts your 7-day free trial. You add your card in the dashboard to activate it, and can cancel any time before it ends.":
    "Aanmelden met Google start je gratis proefperiode van 7 dagen. Je voegt je creditcard toe in het dashboard om die te activeren en kunt altijd opzeggen voordat de periode eindigt.",
  "Your 7-day trial costs €0 today. When it ends, your Grow plan starts automatically at €39 per month excl. VAT unless you cancel first — we email you before the first charge. Paid plans are billed in advance and renew automatically until you cancel in Dashboard → Subscription.":
    "Je proefperiode van 7 dagen kost vandaag €0. Daarna start je Grow-abonnement automatisch voor €39 per maand excl. btw, tenzij je eerst opzegt — we mailen je vóór de eerste afschrijving. Betaalde abonnementen worden vooraf gefactureerd en verlengen automatisch tot je opzegt via Dashboard → Abonnement.",
  "When the 7 days are up, your Grow plan starts automatically at €39 per month excl. VAT and your card is charged. We email you before that happens. Cancel any time in Dashboard → Subscription and nothing is taken.":
    "Na 7 dagen start je Grow-abonnement automatisch voor €39 per maand excl. btw en wordt je kaart belast. We mailen je voordat dat gebeurt. Zeg altijd op via Dashboard → Abonnement en er wordt niets afgeschreven.",
  "Is there really a free trial?": "Is er echt een gratis proefperiode?",
  "What happens when my trial ends?": "Wat gebeurt er als mijn proefperiode eindigt?",
  "Your free trial has ended": "Je gratis proefperiode is afgelopen",
  "Choose my plan": "Kies mijn abonnement",
  "Choose a plan": "Kies een abonnement",

  // ---- insights
  Insights: "Inzichten",
  "PostMint Insights": "PostMint Inzichten",
  "A short read on your week: what happened, what performed and what to promote next.":
    "Kort overzicht van je week: wat er gebeurde, wat presteerde en wat je nu kunt promoten.",
  "This week": "Deze week",
  "What to do next": "Wat je nu kunt doen",
  "Top performing posts": "Best presterende posts",
  "Content pillars": "Contentpijlers",
  Platforms: "Platforms",
  "Coming up": "Binnenkort",
  "See my week": "Bekijk mijn week",
  Refresh: "Vernieuwen",
  "Not used yet": "Nog niet gebruikt",
  "Measured Posts": "Gemeten posts",
  "not enough data yet": "nog te weinig data",

  // ---- connections, publishing, autopilot
  "Connect your socials": "Koppel je socials",
  "Link the accounts you want PostMint to publish to. We use each platform's own sign-in — we never ask for your passwords.":
    "Koppel de accounts waarop PostMint mag publiceren. We gebruiken de inlog van het platform zelf — we vragen nooit om je wachtwoorden.",
  "Simulated connections": "Gesimuleerde koppelingen",
  Publishing: "Publiceren",
  "Approved, not scheduled yet": "Goedgekeurd, nog niet ingepland",
  Scheduled: "Ingepland",
  Published: "Gepubliceerd",
  "Publishing failed": "Publiceren mislukt",
  "Use recommended time": "Gebruik aanbevolen tijd",
  "Publish now": "Nu publiceren",
  Retry: "Opnieuw proberen",
  "Edit post": "Post aanpassen",
  "Reconnect account": "Account opnieuw koppelen",
  "Contact support": "Neem contact op met support",
  "Trusted AutoPilot": "Trusted AutoPilot",
  "Turn AutoPilot on": "Zet AutoPilot aan",
  "Turn AutoPilot off": "Zet AutoPilot uit",
  "Before you switch this on": "Voordat je dit aanzet",
  "When should we post?": "Wanneer mogen we posten?",
  "What may we write?": "Wat mogen we schrijven?",
  "Save my rules": "Bewaar mijn regels",
  "Approve All": "Alles goedkeuren",

  // ---- dashboard nav (V2)
  Create: "Maken",
  Campaigns: "Campagnes",
  Brand: "Merk",
  Media: "Media",
  Connections: "Koppelingen",
  AutoPilot: "AutoPilot",
  Analytics: "Statistieken",

  // ---- navigation & footer
  Home: "Home",
  "How It Works": "Hoe het werkt",
  Services: "Diensten",
  Examples: "Voorbeelden",
  Pricing: "Prijzen",
  "For Businesses": "Voor bedrijven",
  FAQ: "FAQ",
  Contact: "Contact",
  Login: "Inloggen",
  "Get Started": "Aan de slag",
  Dashboard: "Dashboard",
  Logout: "Uitloggen",
  Explore: "Ontdekken",
  Company: "Bedrijf",
  Legal: "Juridisch",
  "Privacy Policy": "Privacybeleid",
  "Terms & Conditions": "Algemene voorwaarden",
  "Cookie Policy": "Cookiebeleid",
  "Subscription Terms": "Abonnementsvoorwaarden",
  "Content Usage Policy": "Beleid voor contentgebruik",
  Disclaimer: "Disclaimer",
  "Your content. Done. A month of social content, without spending your month making it.":
    "Jouw content. Klaar. Een maand social content, zonder er een maand aan te werken.",
  "All rights reserved.": "Alle rechten voorbehouden.",
  "KvK: to be completed · VAT (BTW): to be completed · Registered in the Netherlands":
    "KvK: nog invullen · Btw-nummer: nog invullen · Ingeschreven in Nederland",
  "See Pricing": "Bekijk prijzen",

  // ---- home hero
  "Your content. Done.": "Jouw content. Klaar.",
  "Stop wondering": "Stop met piekeren",
  "what to post.": "over wat je post.",
  "PostMint creates your social media content for you — from post ideas and captions to Reels, promotions and monthly content planning.":
    "PostMint maakt jouw social media content — van postideeën en captions tot Reels, acties en de maandplanning.",
  "Spend less time creating content and more time running your business.":
    "Minder tijd aan content, meer tijd voor je onderneming.",
  "See Examples": "Bekijk voorbeelden",
  "No long-term contract.": "Geen langlopend contract.",
  "Content tailored to your business.": "Content op maat van jouw bedrijf.",
  "Starting from €149/month.": "Vanaf €149 per maand.",
  "Your content plan": "Jouw contentplan",
  "This month · 12 items ready": "Deze maand · 12 items klaar",

  // ---- home trust
  "Built for busy business owners.": "Gemaakt voor drukke ondernemers.",
  "Restaurants & Cafés": "Restaurants & cafés",
  "Beauty & Wellness": "Beauty & wellness",
  "Fitness & Lifestyle": "Fitness & lifestyle",
  "Local Businesses": "Lokale bedrijven",
  "Whether you run a restaurant, salon, gym or local service business, PostMint helps keep your social media active without adding more work to your week.":
    "Of je een restaurant, salon, sportschool of lokale dienstverlener runt: PostMint houdt je social media actief zonder dat je week nog voller wordt.",

  // ---- home problem
  "The problem": "Het probleem",
  'Your business deserves better than "What should we post today?"':
    'Jouw bedrijf verdient beter dan "Wat posten we vandaag?"',
  "No time": "Geen tijd",
  "You are already running your business. Social media often becomes another task on an endless to-do list.":
    "Je runt al een bedrijf. Social media wordt vaak nog een taak op een eindeloze to-dolijst.",
  "No consistency": "Geen regelmaat",
  "Posting once every few weeks makes it harder to stay visible and build an audience.":
    "Eens per paar weken posten maakt het moeilijk om zichtbaar te blijven en volgers op te bouwen.",
  "No ideas": "Geen ideeën",
  "Constantly thinking of captions, promotions and Reel concepts quickly becomes exhausting.":
    "Steeds nieuwe captions, acties en Reel-ideeën bedenken wordt snel vermoeiend.",
  "We handle the content. You run the business.": "Wij doen de content. Jij runt de zaak.",
  "Tell us about your company, upload your photos and promotions, and we turn them into a structured monthly content plan.":
    "Vertel ons over je bedrijf, upload je foto's en acties, en wij maken er een gestructureerd maandplan van.",

  // ---- home steps
  "How it works": "Hoe het werkt",
  "Four steps to a full month of content.": "Vier stappen naar een volle maand content.",
  "Tell us about your business": "Vertel ons over je bedrijf",
  "Complete your PostMint Brand Profile. Tell us about your products, services, target customers, brand personality and goals.":
    "Vul je PostMint Merkprofiel in. Vertel over je producten, diensten, doelgroep, merkpersoonlijkheid en doelen.",
  "Upload your content": "Upload je content",
  "Upload photos, videos, logos, menus, promotions or other materials you want us to work with.":
    "Upload foto's, video's, logo's, menukaarten, acties of ander materiaal waarmee wij aan de slag gaan.",
  "We create your content": "Wij maken je content",
  "PostMint creates your monthly content calendar, captions, promotional posts and video ideas.":
    "PostMint maakt je maandkalender, captions, actieposts en video-ideeën.",
  "Review and publish": "Bekijk en publiceer",
  "Review your content, request adjustments and publish it according to your schedule.":
    "Bekijk je content, vraag aanpassingen aan en publiceer volgens jouw planning.",
  "Create My Content Plan": "Maak mijn contentplan",

  // ---- home benefits
  Benefits: "Voordelen",
  "Social media without the social media headache.": "Social media zonder de social media-stress.",
  "Save Time": "Tijd besparen",
  "Stop spending hours every week thinking about what to post.":
    "Niet meer elke week uren nadenken over wat je moet posten.",
  "Stay Consistent": "Blijf consistent",
  "Receive structured content every month.": "Ontvang elke maand gestructureerde content.",
  "Look Professional": "Oog professioneel",
  "Keep your brand and messaging consistent.": "Houd je merk en boodschap consistent.",
  "Promote More": "Promoot meer",
  "Turn offers, events and promotions into social media content quickly.":
    "Zet aanbiedingen, events en acties snel om in social media content.",
  "Generate More Ideas": "Meer ideeën",
  "Never run out of ideas for posts or short-form videos.":
    "Nooit meer zonder ideeën voor posts of korte video's.",
  "Stay in Control": "Jij houdt de regie",
  "Nothing is published without your approval.": "Niets wordt gepubliceerd zonder jouw goedkeuring.",

  // ---- examples
  "Example concepts": "Voorbeeldconcepten",
  "See what PostMint can create.": "Zie wat PostMint kan maken.",
  "Pick a business type and see the kind of post, story and Reel concept you would receive.":
    "Kies een type bedrijf en zie welke post, story en Reel je zou ontvangen.",
  "Example Concept": "Voorbeeldconcept",
  Business: "Bedrijf",
  Promotion: "Actie",
  "Instagram Post": "Instagram-post",
  "Instagram Story": "Instagram-story",
  "Reel idea": "Reel-idee",
  "Promotional angle": "Promotie-insteek",
  "See all examples": "Bekijk alle voorbeelden",
  "Content concepts, by industry.": "Contentconcepten per branche.",
  "Business type": "Type bedrijf",
  Objective: "Doel",
  Caption: "Caption",
  "Reel concept": "Reel-concept",
  "Promotional idea": "Promotie-idee",
  All: "Alles",
  Restaurant: "Restaurant",
  Café: "Café",
  Beauty: "Beauty",
  Barber: "Barbier",
  Fitness: "Fitness",
  Automotive: "Automotive",
  Retail: "Retail",
  Hospitality: "Horeca",
  "No examples in this category yet.": "Nog geen voorbeelden in deze categorie.",
  "Want this for your business?": "Wil je dit voor jouw bedrijf?",
  "Choose a package and we'll build your first content month around your brand.":
    "Kies een pakket en wij bouwen je eerste contentmaand rond jouw merk.",

  // ---- final CTA
  "One less thing on your to-do list.": "Eén ding minder op je to-dolijst.",
  "Let PostMint take care of your social content.": "Laat PostMint je social content verzorgen.",

  // ---- how it works page
  "From business information to a full month of content.":
    "Van bedrijfsinformatie naar een volle maand content.",
  "Every PostMint customer receives a personalised Brand Profile. It is the foundation we use to keep every future post recognisably yours.":
    "Elke PostMint-klant krijgt een persoonlijk Merkprofiel. Dat is de basis waarmee elke volgende post herkenbaar jouw stijl houdt.",
  "Brand Profile": "Merkprofiel",
  "One profile. Consistent content.": "Één profiel. Consistente content.",
  "Your Brand Profile stores everything we need so your content stays consistent month after month — no repeated briefings, no starting from scratch.":
    "Je Merkprofiel bewaart alles wat wij nodig hebben, zodat je content maand na maand consistent blijft — geen briefings herhalen, nooit meer vanaf nul.",
  "Customer journey": "Klantreis",
  "What happens, step by step.": "Wat er gebeurt, stap voor stap.",
  "Sign Up": "Aanmelden",
  "Choose a package and create your account.": "Kies een pakket en maak je account aan.",
  "Build Your Brand Profile": "Vul je Merkprofiel in",
  "Answer questions about your business.": "Beantwoord vragen over je bedrijf.",
  "Upload Content": "Content uploaden",
  "Add photos, videos, logos and promotional information.":
    "Voeg foto's, video's, logo's en actie-informatie toe.",
  "Monthly Content Creation": "Maandelijkse contentcreatie",
  "PostMint prepares your content.": "PostMint maakt je content klaar.",
  Review: "Beoordelen",
  "Review everything from your dashboard.": "Bekijk alles vanuit je dashboard.",
  "Request Changes": "Wijzigingen aanvragen",
  "Request changes before final delivery.": "Vraag wijzigingen aan vóór de definitieve oplevering.",
  "Download or Publish": "Downloaden of publiceren",
  "Download social media graphics, captions and your content calendar.":
    "Download je social media beelden, captions en contentkalender.",

  // ---- services page
  "Everything you need to stay active online.": "Alles wat je nodig hebt om online actief te blijven.",
  "Pick a package and we take care of the ideas, the writing and the planning. You stay in control of what goes out.":
    "Kies een pakket en wij verzorgen de ideeën, de teksten en de planning. Jij bepaalt wat er live gaat.",
  "Social Media Posts": "Social media posts",
  "Post concepts tailored to your business, products and audience.":
    "Postconcepten op maat van jouw bedrijf, producten en doelgroep.",
  "Caption Writing": "Captions schrijven",
  "Professional captions matching your business's tone of voice.":
    "Professionele captions die passen bij de tone of voice van je bedrijf.",
  "Content Calendars": "Contentkalenders",
  "A clear monthly posting schedule so you always know what goes out when.":
    "Een heldere maandplanning, zodat je altijd weet wat wanneer online gaat.",
  "Reel & TikTok Ideas": "Reel- & TikTok-ideeën",
  "Short-form video concepts including hook, video idea, shot list, text overlay, caption and call to action.":
    "Korte videoconcepten met hook, video-idee, shotlijst, tekst in beeld, caption en call to action.",
  "Promotional Content": "Actiecontent",
  "Content for special offers, events, new products, holiday campaigns, seasonal promotions, sales, menu changes and new services.":
    "Content voor aanbiedingen, events, nieuwe producten, feestdagencampagnes, seizoensacties, sales, menuwijzigingen en nieuwe diensten.",
  "Promotional Graphics": "Promotiebeelden",
  "Branded graphics designed for social media feeds and stories.":
    "Beelden in jouw huisstijl, gemaakt voor social media feeds en stories.",
  "Review Responses": "Reacties op reviews",
  "Professional responses to Google reviews, Facebook reviews and customer feedback.":
    "Professionele reacties op Google-reviews, Facebook-reviews en klantfeedback.",
  "Campaign Ideas": "Campagne-ideeën",
  "Monthly marketing campaign concepts built around your goals.":
    "Maandelijkse campagneconcepten rond jouw doelen.",
  "Not sure which services you need?": "Weet je niet welke diensten je nodig hebt?",
  "Most businesses start with posts, captions and a content calendar, then add Reels and promotional graphics once they see what works. You can change your package at any time.":
    "De meeste bedrijven beginnen met posts, captions en een contentkalender en voegen later Reels en promotiebeelden toe. Je kunt je pakket altijd aanpassen.",

  // ---- pricing page
  "Simple monthly pricing.": "Eenvoudige maandprijzen.",
  "No complicated agency contracts. Choose the amount of support your business needs.":
    "Geen ingewikkelde bureaucontracten. Kies de hoeveelheid ondersteuning die jouw bedrijf nodig heeft.",
  "MOST POPULAR": "MEEST GEKOZEN",
  "/ month": "/ maand",
  "For businesses that mainly need consistent posts.":
    "Voor bedrijven die vooral consistente posts nodig hebben.",
  "For businesses serious about growing their social media presence.":
    "Voor bedrijven die serieus willen groeien op social media.",
  "For businesses wanting a more complete content service.":
    "Voor bedrijven die een completere contentservice willen.",
  "Choose Start": "Kies Start",
  "Choose Grow": "Kies Grow",
  "Choose Pro": "Kies Pro",
  "All prices shown excluding VAT where legally applicable.":
    "Alle genoemde prijzen zijn exclusief btw waar dat wettelijk van toepassing is.",
  "Cancel according to the subscription terms. No unnecessary long-term commitment.":
    "Opzeggen volgens de abonnementsvoorwaarden. Geen onnodige langlopende verplichting.",
  "Pricing FAQ": "Veelgestelde vragen over prijzen",
  "Questions about the packages.": "Vragen over de pakketten.",

  // ---- for businesses
  "Made for businesses that have better things to do than make Instagram posts.":
    "Gemaakt voor bedrijven die beter te doen hebben dan Instagram-posts maken.",
  "Content examples": "Voorbeelden van content",
  Restaurants: "Restaurants",
  Cafés: "Cafés",
  "Beauty Salons": "Beautysalons",
  Barbers: "Barbiers",
  Gyms: "Sportscholen",
  "Don't see your industry?": "Staat jouw branche er niet bij?",
  "PostMint can work with almost any business that needs regular social media content.":
    "PostMint werkt met vrijwel elk bedrijf dat regelmatig social media content nodig heeft.",
  "Tell Us About Your Business": "Vertel ons over je bedrijf",

  // ---- faq page
  "Frequently asked questions.": "Veelgestelde vragen.",
  "Still unsure about something? Send us a message and we'll answer directly.":
    "Nog iets onduidelijk? Stuur ons een bericht en we antwoorden persoonlijk.",

  // ---- contact page
  "Tell us about your business.": "Vertel ons over je bedrijf.",
  "Send us a message and we'll get back to you. Response times may vary depending on demand and package. We do not offer 24/7 support.":
    "Stuur ons een bericht en we nemen contact op. Reactietijden kunnen variëren afhankelijk van drukte en pakket. We bieden geen 24/7 support.",
  "Name *": "Naam *",
  "Business Name": "Bedrijfsnaam",
  "Email *": "E-mailadres *",
  Topic: "Onderwerp",
  "Message *": "Bericht *",
  "Send Message": "Bericht versturen",
  "Sending…": "Versturen…",
  "Message sent": "Bericht verstuurd",
  "Thanks for reaching out. We'll come back to you as soon as we can.":
    "Bedankt voor je bericht. We komen zo snel mogelijk bij je terug.",
  Email: "E-mail",
  "Based in": "Gevestigd in",
  "Rotterdam, the Netherlands": "Rotterdam, Nederland",
  Support: "Support",
  "Response times vary by demand and package.": "Reactietijden variëren per drukte en pakket.",
  "Please enter your name.": "Vul je naam in.",
  "Please enter a valid email address.": "Vul een geldig e-mailadres in.",
  "Please tell us a little more (at least 10 characters).":
    "Vertel ons iets meer (minimaal 10 tekens).",

  // ---- auth pages
  "Welcome back.": "Welkom terug.",
  "Log in to review your content and manage your account.":
    "Log in om je content te bekijken en je account te beheren.",
  "Continue with Google": "Doorgaan met Google",
  "or use email": "of gebruik e-mail",
  Password: "Wachtwoord",
  "Remember me": "Ingelogd blijven",
  "Forgot password?": "Wachtwoord vergeten?",
  "Logging in…": "Inloggen…",
  "Don't have an account?": "Nog geen account?",
  "Let's build your content plan.": "Laten we je contentplan maken.",
  "Two quick steps: pick the level of support you want, then create your account. You'll complete your Brand Profile right after.":
    "Twee snelle stappen: kies het niveau van ondersteuning en maak je account aan. Daarna vul je je Merkprofiel in.",
  "Step 1": "Stap 1",
  "Step 2": "Stap 2",
  "Choose package": "Kies een pakket",
  "Create account": "Maak een account",
  "Sign up with Google": "Aanmelden met Google",
  "First Name *": "Voornaam *",
  "Last Name *": "Achternaam *",
  "Business Name *": "Bedrijfsnaam *",
  "Email Address *": "E-mailadres *",
  "Phone Number": "Telefoonnummer",
  "Password *": "Wachtwoord *",
  "Confirm Password *": "Wachtwoord bevestigen *",
  Continue: "Doorgaan",
  "Creating account…": "Account aanmaken…",
  "Already have an account?": "Heb je al een account?",
  "Prices exclude VAT where legally applicable. Payment is set up after your account is created — no card is charged during signup.":
    "Prijzen zijn exclusief btw waar wettelijk van toepassing. Betalen regel je na het aanmaken van je account — tijdens aanmelden wordt niets afgeschreven.",
  "Please enter your first name.": "Vul je voornaam in.",
  "Please enter your last name.": "Vul je achternaam in.",
  "Please enter your business name.": "Vul je bedrijfsnaam in.",
  "Please use at least 8 characters.": "Gebruik minimaal 8 tekens.",
  "Passwords do not match.": "De wachtwoorden zijn niet gelijk.",
  "Please accept the Terms & Conditions and Privacy Policy.":
    "Accepteer de algemene voorwaarden en het privacybeleid.",
  "Please enter your password.": "Vul je wachtwoord in.",

  // ---- cookie consent
  "We respect your privacy": "We respecteren je privacy",
  "We use necessary cookies to run this website. Analytics and marketing cookies are only used with your consent, in line with GDPR/AVG.":
    "We gebruiken noodzakelijke cookies om deze website te laten werken. Analytische en marketingcookies gebruiken we alleen met jouw toestemming, conform de AVG.",
  "Accept All": "Alles accepteren",
  "Reject Non-Essential": "Niet-essentiële weigeren",
  "Manage Preferences": "Voorkeuren beheren",
  "Save Preferences": "Voorkeuren opslaan",
  Necessary: "Noodzakelijk",
  "Required for the website to function. Always on.":
    "Nodig om de website te laten werken. Altijd aan.",
  Analytics: "Analytisch",
  "Helps us understand how the website is used.":
    "Helpt ons begrijpen hoe de website gebruikt wordt.",
  Marketing: "Marketing",
  "Used to measure and improve campaigns.": "Gebruikt om campagnes te meten en te verbeteren.",

  // ---- dashboard shell
  Overview: "Overzicht",
  "My Content": "Mijn content",
  "My Tasks": "Mijn taken",
  "Content Calendar": "Contentkalender",
  "Your cookie choice": "Jouw cookiekeuze",
  "We use necessary cookies to run this website and keep you signed in. Preference, analytics and marketing cookies are only used if you allow them — nothing non-essential loads before you choose.":
    "We gebruiken noodzakelijke cookies om deze website te laten werken en je ingelogd te houden. Voorkeur-, analyse- en marketingcookies gebruiken we alleen als jij daar toestemming voor geeft — niets niet-essentieels laadt voordat jij kiest.",
  "Accept all": "Alles accepteren",
  "Reject non-essential": "Niet-essentiële weigeren",
  "Manage preferences": "Voorkeuren beheren",
  "Save preferences": "Voorkeuren opslaan",
  "Cookie settings": "Cookie-instellingen",
  "Terms of Service": "Algemene voorwaarden",
  "Acceptable Use Policy": "Gebruiksvoorwaarden",
  "Data Processing Agreement": "Verwerkersovereenkomst",
  "Refund & Cancellation": "Terugbetaling & opzeggen",
  "Refund & Cancellation Policy": "Terugbetalings- en opzegbeleid",
  "Trust & Security": "Vertrouwen & beveiliging",
  "Legal Notice": "Juridische informatie",
  "Company details": "Bedrijfsgegevens",
  "Company details & legal notice": "Bedrijfsgegevens en juridische informatie",
  "Complaints": "Klachten",
  "Before you subscribe": "Voordat je een abonnement neemt",
  "Full details:": "Volledige details:",
  "Product": "Product",
  "Support": "Support",
  "Necessary": "Noodzakelijk",
  "Preferences": "Voorkeuren",
  "Analytics": "Analyse",
  "Marketing": "Marketing",
  "We never sell your details.": "We verkopen jouw gegevens nooit.",
  "Your social media. Almost on autopilot. Create, plan, approve and publish your content from one place.":
    "Jouw social media. Bijna op de automatische piloot. Maak, plan, keur goed en publiceer je content vanaf één plek.",
  "7 days free, then from": "7 dagen gratis, daarna vanaf",
  "Photo To Post": "Foto naar post",
  "A month of posts for your business, written and planned for you. You approve — that's the whole job.":
    "Een maand posts voor jouw bedrijf, geschreven en ingepland. Jij keurt goed — dat is het hele werk.",
  "Three steps. Then a few minutes a week.": "Drie stappen. Daarna een paar minuten per week.",
  "What you actually receive.": "Wat je écht krijgt.",

  "/month excl. VAT": "/maand excl. btw",
  "Compare all plans": "Vergelijk alle pakketten",
  "Examples": "Voorbeelden",
  "Pricing": "Prijzen",
  "How To Post": "Zo publiceer je",
  "How to post your content": "Zo publiceer je jouw content",
  "PostMint learns your business and drafts your social media content, builds your calendar and publishes the posts you approve.":
    "PostMint leert jouw bedrijf kennen, schrijft je socialmediacontent, bouwt je kalender en publiceert de posts die jij goedkeurt.",
  "Turn a photo into a post": "Maak van een foto een post",
  "Your reel script": "Jouw reelscript",
  "Your photos": "Jouw foto's",
  Promotions: "Acties",
  "Upload Media": "Media uploaden",
  Requests: "Aanvragen",
  Subscription: "Abonnement",
  Billing: "Facturatie",
  Settings: "Instellingen",

  // ---- 404
  "This page doesn't exist.": "Deze pagina bestaat niet.",
  "The link may be out of date. Head back to the homepage or take a look at the pricing.":
    "De link is misschien verouderd. Ga terug naar de homepage of bekijk de prijzen.",
  "Back to Home": "Terug naar home",

  // ---- package features
  "8 social media posts": "8 social media posts",
  "8 professionally written captions": "8 professioneel geschreven captions",
  "Monthly content calendar": "Maandelijkse contentkalender",
  "Content ideas tailored to the business": "Contentideeën op maat van het bedrijf",
  "Hashtag recommendations where relevant": "Hashtag-advies waar relevant",
  "1 revision round": "1 revisieronde",
  "Email support": "Support via e-mail",
  "12 social media posts": "12 social media posts",
  "12 captions": "12 captions",
  "4 Reel/TikTok concepts": "4 Reel/TikTok-concepten",
  "2 promotional graphic concepts": "2 concepten voor promotiebeelden",
  "Content strategy suggestions": "Suggesties voor contentstrategie",
  "Promotion and event content": "Content voor acties en events",
  "2 revision rounds": "2 revisierondes",
  "Priority email support": "Prioriteit-support via e-mail",
  "16 social media posts": "16 social media posts",
  "16 captions": "16 captions",
  "8 Reel/TikTok concepts": "8 Reel/TikTok-concepten",
  "4 promotional graphics": "4 promotiebeelden",
  "Review response content": "Reacties op reviews",
  "1 monthly campaign concept": "1 campagneconcept per maand",
  "Seasonal content strategy": "Seizoensgebonden contentstrategie",
  "Priority revisions": "Revisies met prioriteit",
  "Priority support": "Support met prioriteit",

  // ---- pricing FAQ
  "Can I change packages?": "Kan ik van pakket wisselen?",
  "Yes. You can upgrade or downgrade from the Subscription page in your dashboard. Changes apply to your next content month.":
    "Ja. Je kunt upgraden of downgraden via de pagina Abonnement in je dashboard. Wijzigingen gelden vanaf je volgende contentmaand.",
  "Can I cancel my subscription?": "Kan ik mijn abonnement opzeggen?",
  "Yes. You can cancel from your dashboard according to the subscription terms. We do not hide the cancellation option.":
    "Ja. Je kunt opzeggen via je dashboard, volgens de abonnementsvoorwaarden. We verstoppen die optie niet.",
  "Are the posts automatically published?": "Worden de posts automatisch gepubliceerd?",
  "No. You receive your content to review and publish yourself, unless automatic scheduling is separately offered and agreed.":
    "Nee. Je ontvangt je content om zelf te beoordelen en te publiceren, tenzij automatisch inplannen apart is afgesproken.",
  "Can you use my own photos?": "Kunnen jullie mijn eigen foto's gebruiken?",
  "Yes. You can upload photos, videos and other materials in your dashboard and we build content around them.":
    "Ja. Je uploadt foto's, video's en ander materiaal in je dashboard en wij bouwen daar content rond.",
  "Can you create content in Dutch?": "Maken jullie content in het Nederlands?",
  "Yes. Dutch is one of our two main content languages.":
    "Ja. Nederlands is een van onze twee hoofdtalen voor content.",
  "Can you create content in English?": "Maken jullie content in het Engels?",
  "Yes. English is one of our two main content languages.":
    "Ja. Engels is een van onze twee hoofdtalen voor content.",
  "Can you create bilingual content?": "Maken jullie tweetalige content?",
  "Yes. You can request Dutch + English content in your Brand Profile.":
    "Ja. In je Merkprofiel kun je content in Nederlands + Engels aanvragen.",
  "Do you create videos?": "Maken jullie video's?",
  "We create Reel and TikTok concepts including hooks, shot lists, text overlays and captions. Filming is done by you unless separately agreed.":
    "We maken Reel- en TikTok-concepten met hooks, shotlijsten, tekst in beeld en captions. Het filmen doe jij, tenzij anders afgesproken.",
  "How many revisions are included?": "Hoeveel revisies zijn inbegrepen?",
  "Start includes 1 revision round, Grow includes 2 and Pro includes priority revisions. Your remaining rounds are shown in your dashboard.":
    "Start bevat 1 revisieronde, Grow 2 en Pro heeft revisies met prioriteit. Je resterende rondes zie je in je dashboard.",
  "What happens after I subscribe?": "Wat gebeurt er na mijn aanmelding?",
  "You create your account, complete your Brand Profile, upload your materials and we start preparing your content month.":
    "Je maakt je account aan, vult je Merkprofiel in, uploadt je materiaal en wij beginnen met je contentmaand.",

  // ---- general FAQ
  "What is PostMint?": "Wat is PostMint?",
  "PostMint is a social media content service for businesses. We help create social media ideas, captions, promotional posts, content calendars and short-form video concepts.":
    "PostMint is een social media contentservice voor bedrijven. We maken ideeën, captions, actieposts, contentkalenders en korte videoconcepten.",
  "Is PostMint an AI tool?": "Is PostMint een AI-tool?",
  "PostMint uses modern technology and AI-assisted workflows to help create content efficiently, but all services are designed around each customer's individual business and content needs.":
    "PostMint gebruikt moderne technologie en AI-ondersteunde workflows om efficiënt content te maken, maar alle diensten zijn opgebouwd rond het bedrijf en de contentwensen van elke klant.",
  "Will my content look generic?": "Wordt mijn content niet generiek?",
  "No. Customers complete a detailed Brand Profile that helps tailor content to their business, audience, tone and services.":
    "Nee. Klanten vullen een uitgebreid Merkprofiel in, waarmee we content afstemmen op hun bedrijf, doelgroep, tone of voice en diensten.",
  "Can I request changes?": "Kan ik wijzigingen aanvragen?",
  "Yes. Revision allowances depend on the selected package.":
    "Ja. Het aantal revisies hangt af van het gekozen pakket.",
  "Do you automatically publish my posts?": "Publiceren jullie mijn posts automatisch?",
  "Initially, customers receive their content to review and publish themselves unless automatic scheduling is separately offered.":
    "In eerste instantie ontvang je je content om zelf te beoordelen en te publiceren, tenzij automatisch inplannen apart wordt aangeboden.",
  "Can you work with my existing photos?": "Kunnen jullie met mijn bestaande foto's werken?",
  Yes: "Ja",
  "Can I upload videos?": "Kan ik video's uploaden?",
  "Yes. MP4 and MOV files are supported in your dashboard.":
    "Ja. MP4- en MOV-bestanden worden ondersteund in je dashboard.",
  "Can I send you promotions during the month?": "Kan ik gedurende de maand acties doorgeven?",
  "Yes. Submit new promotions at any time through the Promotions page in your dashboard and we will factor them into your content.":
    "Ja. Geef nieuwe acties op elk moment door via de pagina Acties in je dashboard en wij nemen ze mee in je content.",
  "What languages can you create content in?": "In welke talen maken jullie content?",
  "Dutch and English are the main options. You can also request bilingual content.":
    "Nederlands en Engels zijn de hoofdopties. Tweetalige content kan ook.",
  "Are the prices including VAT?": "Zijn de prijzen inclusief btw?",
  "Prices shown on this website are business prices excluding VAT where VAT legally applies. Your invoice shows the exact VAT treatment according to our final tax setup.":
    "De prijzen op deze website zijn zakelijke prijzen exclusief btw waar btw wettelijk van toepassing is. Op je factuur staat de exacte btw-behandeling volgens onze definitieve fiscale opzet.",
  "How quickly do I receive my content?": "Hoe snel ontvang ik mijn content?",
  "Delivery timelines are shown during onboarding and may depend on your package and the completeness of the materials you provide. We do not promise unrealistic turnaround times.":
    "Levertijden zie je tijdens de onboarding en kunnen afhangen van je pakket en de volledigheid van het materiaal dat je aanlevert. We beloven geen onrealistische levertijden.",
};
